import { useState, useEffect } from "react";

function evaluateOnBehalfOf(onBehalfOf) {
	const currentOrgId =
		sessionStorage.getItem("config") &&
		JSON.parse(sessionStorage.getItem("config")).identity?.organization?.id;
	if (
		!currentOrgId ||
		onBehalfOf?.length < 1 ||
		(onBehalfOf?.length === 1 && onBehalfOf[0].id === currentOrgId)
	) {
		return false;
	}
	return true;
}

const useBehalfPanel = (onBehalfOf) => {
	const [behalfPanel, setBehalfPanel] = useState(
		evaluateOnBehalfOf(onBehalfOf)
	);

	useEffect(() => {
		setBehalfPanel(evaluateOnBehalfOf(onBehalfOf));
	}, [onBehalfOf]);

	return [behalfPanel, setBehalfPanel];
};

export default useBehalfPanel;
